export const LeaseStepActionConst = {
    LEASE_STEP_CHANGE: "LEASE_STEP_CHANGE",

}

